// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import PageContainer from 'src/components/container/PageContainer';
// import DashboardCard from 'src/components/shared/DashboardCard';
// import { Button, Grid, MenuItem, Select, ToggleButton, ToggleButtonGroup , FormControl} from '@mui/material';
// import { Box } from '@mui/system';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import { useMain } from '../hooks/useMain';
// import TextInputs from 'src/components/inputs/TextInputs';
// import Suggestion from './Suggestion';
// import SelectInputs from 'src/components/inputs/SelectInputs';


// const initialValue = {
//   productName: '',
//   // mrp: '',
//   volume: '',
//   unit: '',
//   productCount: '',
//   sellPrice: '',
//   rewardPoints: '',
//   staffIncentive: '',
//   incentiveType: '%', // default value
//   hsnCode: '',
//   GST: 18,
//   taxStatus: 'No GST',
// };

// const initialFormValidation = {
//   productNameValidation: false,
//   // mrpValidation: false,
//   sellPriceValidation: false,
//   productCountValidation: false,
// };

// const incentiveTypes = ['%', 'INR'];

// const AddProduct = () => {
//   const { createProduct, activeBranchId, getBranch, setShowMessage, branchData } = useMain();

//   const [formData, setFormData] = useState(initialValue);
//   const [formValidation, setFormValidation] = useState(initialFormValidation);
//   const [productData, setProductData] = useState([]);
//   const [suggested, setSuggested] = useState([]);
//   const [activeField, setActiveField] = useState('');
//   const [loading, setLoading] = useState(false);
//   const hasGstNumber = Boolean(String(branchData?.gstNumber || '').trim());

//   // Add this ref for the product name input
//   const productNameInputRef = useRef(null);

//   const productNameValidation = !formData.productName.trim();
//   // const mrpValidation = !formData.mrp || !(Number(formData.mrp) > 0);
//   const sellPriceValidation = !formData.sellPrice || !(Number(formData.sellPrice) > 0);
//   const productCountValidation = !formData.productCount || !(Number(formData.productCount) > 0);
//   // const hsnCodeValidation = !formData.productName.trim();

//   const taxableValue = useMemo(() => {
//     const p = Number(formData.sellPrice) || 0;
//     const gstRate = Number(formData.GST) || 0;
//     if (formData.taxStatus === 'withTax' && gstRate > 0) {
//       return (p / (1 + gstRate / 100)).toFixed(2);
//     }
//     return p.toFixed(2);
//   }, [formData.sellPrice, formData.GST, formData.taxStatus]);

//   // Add this useEffect to focus on the product name field when component mounts
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (productNameInputRef.current) {
//         productNameInputRef.current.focus();
//       }
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//     if (name === 'productName' || name === 'vendorName') {
//       updateSuggested(name, value);
//     }
//   };

//   const updateSuggested = (fieldName, inputValue) => {
//     if (inputValue === '') {
//       setSuggested([]);
//     } else {
//       const suggestions = productData
//         .filter((product) =>
//           product[fieldName === 'productName' ? 'productName' : 'vendorName']
//             ?.toLowerCase()
//             .includes(inputValue.toLowerCase()),
//         )
//         .map((product) => product[fieldName === 'productName' ? 'productName' : 'vendorName']);
//       setSuggested(suggestions);
//     }
//   };

//   const handleSuggestedClick = (suggestedName) => {
//     const updatedFormData = { ...formData };
//     if (activeField === 'productName' || activeField === 'vendorName') {
//       updatedFormData[activeField] = suggestedName;
//     }
//     setFormData(updatedFormData);
//     setSuggested([]);
//   };

//   const handleSubmit = async () => {
//     const { productName, productCount, sellPrice, taxStatus } = formData;
//     console.log(formData, 'formData')
//     const validation = {
//       productNameValidation: !productName.trim(),
//       // mrpValidation: !mrp || !(Number(mrp) > 0),
//       sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
//       productCountValidation: !productCount || !(Number(productCount) > 0),
//       taxStatusValidation: hasGstNumber ? !taxStatus : false,
//     };

//     setFormValidation((pre) => ({ ...pre, ...validation }));

//     if (Object.values(validation).some((item) => item)) return;
//     const payload = {
//       ...formData,
//       GST: hasGstNumber ? formData.GST : 0,
//       taxStatus: hasGstNumber ? formData.taxStatus : 'noGst',
//       taxableValue: taxableValue,
//       branchDetails: activeBranchId,
//     };

//     try {
//       setLoading(true);
//       const res = await createProduct(JSON.stringify(payload));
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Product has been created successfully',
//           messageType: 'success',
//         });
//         setFormData(initialValue);
//         setFormValidation((pre) => ({ ...initialFormValidation }));
//       } else {
//         setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputFocus = () => {
//     setSuggested([]);
//     const activeElement = document.activeElement;
//     if (activeElement && activeElement.getAttribute('name')) {
//       setActiveField(activeElement.getAttribute('name'));
//     } else {
//       setActiveField('');
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('focus', handleInputFocus, true);
//     return () => {
//       document.removeEventListener('focus', handleInputFocus, true);
//     };
//   }, [activeField]);

//   const getData = async () => {
//     try {
//       const res = await getBranch(activeBranchId);
//       if (res.statusCode === 200) {
//         const data = res?.data;
//         setProductData(data?.products || []);
//       } else {
//       }
//     } catch (error) { }
//   };

//   useEffect(() => {
//     if (activeBranchId) getData();
//   }, [activeBranchId]);


//   // This logic disables the mouse wheel event
//   useEffect(() => {
//     const handleWheel = (e) => {
//       if (document.activeElement.type === 'number') {
//         document.activeElement.blur();
//       }
//     };

//     window.addEventListener('wheel', handleWheel);
//     return () => {
//       window.removeEventListener('wheel', handleWheel);
//     };
//   }, []);

//   const handleIncentiveTypeChange = (event, newIncentiveType) => {
//     if (newIncentiveType !== null) {
//       setFormData({ ...formData, incentiveType: newIncentiveType });
//     }
//   };


//   return (
//     <PageContainer title="Add New Product" description="This is add Product">
//       <DashboardCard title="Add New Product">
//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3} justify="center">
//             {/* <Grid item xs={12} md={4}>
//               <TextInputs
//                 required={false}
//                 title={'Vendor Name'}
//                 name={'vendorName'}
//                 value={formData?.vendorName}
//                 handleChange={handleChange}
//                 type={'text'}
//               />
//               {suggested.length > 0 && activeField === 'vendorName' && (
//                 <Suggestion data={suggested} handleSuggestedClick={handleSuggestedClick} />
//               )}
//             </Grid> */}
//             <Grid item xs={12} md={3}>
//               <TextInputs
//                 title={'HSN Code'}
//                 name={'hsnCode'}
//                 value={formData?.hsnCode}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'HSN Code'}
//                 required={false}
//               />
//             </Grid>
//             <Grid item xs={12} md={5}>
//               <TextInputs
//                 title={'Product Name'}
//                 ref={productNameInputRef}
//                 name={'productName'}
//                 value={formData?.productName}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'Product Name'}
//                 fieldValidation={productNameValidation && formValidation.productNameValidation}
//               />
//               {suggested.length > 0 && activeField === 'productName' && (
//                 <Suggestion data={suggested} handleSuggestedClick={handleSuggestedClick} />
//               )}
//             </Grid>
//             <Grid item xs={12} md={4}>
//               <div style={{ marginBottom: '4px', fontWeight: 600, fontSize: '15px', color: '#212529' }}>Volume</div>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   border: '1px solid #ced4da',
//                   borderRadius: '4px',
//                   height: '57px',
//                   transition: 'border-color 0.2s ease-in-out',
//                   '&:hover': { borderColor: '#6174DD' },
//                 }}
//               >
//                 <input
//                   name="volume"
//                   placeholder="0"
//                   value={formData?.volume}
//                   onChange={handleChange}
//                   type="number"
//                   min="0"
//                   style={{
//                     border: 'none',
//                     outline: 'none',
//                     flex: 1,
//                     padding: '12px 12px',
//                     fontSize: '16px',
//                     background: 'transparent',
//                     width: '100%',
//                   }}
//                 />
//                 <Select
//                   name="unit"
//                   value={formData?.unit}
//                   onChange={handleChange}
//                   displayEmpty
//                   sx={{
//                     background: '#F0F0F0',
//                     border: 'none',
//                     height: '100%',
//                     borderTopLeftRadius: '0px',
//                     borderBottomLeftRadius: '0px',
//                     borderTopRightRadius: '3px',
//                     borderBottomRightRadius: '3px',
//                     '& .MuiSelect-select': {
//                       padding: '8px 16px',
//                       paddingRight: '24px !important',
//                       height: '100% !important',
//                       display: 'flex',
//                       alignItems: 'center',
//                     },
//                     '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
//                     '&:hover': { background: '#e0e0e0' },
//                     '&.Mui-focused': { background: '#e0e0e0' },
//                     borderLeft: '1px solid #ced4da',
//                   }}
//                 >
//                   {['ml', 'l', 'gm', 'kg'].map((type) => (
//                     <MenuItem key={type} value={type}>
//                       {type}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </Box>
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             {/* <Grid item xs={12} md={3}>
//               <TextInputs
//                 title={'MRP'}
//                 name={'mrp'}
//                 placeholder="0"
//                 value={formData?.mrp}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//                 fieldValidation={mrpValidation && formValidation.mrpValidation}
//               />
//             </Grid> */}
//             {/* <Grid item xs={12} md={3}>
//               <TextInputs
//                 required={false}
//                 title={'Purchase Price'}
//                 name={'purchasePrice'}
//                 placeholder="
//                 placeholder="0"
//                 value={formData?.purchasePrice}
//                 handleChange={handleChange}
//                 type={'number'}
//               />
//             </Grid> */}
//             {/* Selling price are showing as a mrp because mrp is comment out */}
//             <Grid item xs={12} md={3}>
//                 <FormControl fullWidth>
//                   <label style={{
//                     fontSize: "15px",
//                     fontWeight: 600,
//                     marginBottom: "4px",
//                     display: "inline-block",
//                     color: "#212529"
//                   }}>MRP <span style={{ color: 'red' }}>*</span></label>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       border: `1px solid ${sellPriceValidation && formValidation.sellPriceValidation ? 'red' : '#ced4da'}`,
//                       borderRadius: '4px',
//                       height: "57px",
//                       transition: 'border-color 0.2s ease-in-out',
//                       '&:hover': {
//                         borderColor: '#6174DD',
//                       },
//                     }}
//                   >
//                     <span style={{ padding: '0px 8px', fontSize: '16px', color: '#666' }}>₹</span>
//                     <input
//                       name="sellPrice"
//                       placeholder="0"
//                       value={formData?.sellPrice}
//                       onChange={handleChange}
//                       type="number"
//                       min="0"
//                       style={{
//                         border: 'none',
//                         outline: 'none',
//                         flex: 1,
//                         padding: '12px 0px',
//                         fontSize: '16px',
//                         background: 'transparent',
//                         width: '100%'
//                       }}
//                     />
//                     {hasGstNumber && (
//                       <Select
//                         name="taxStatus"
//                         value={formData?.taxStatus || 'noGst'}
//                         onChange={handleChange}
//                         displayEmpty
//                         inputProps={{ 'aria-label': 'Without label' }}
//                         sx={{
//                           background: '#F0F0F0',
//                           border: 'none',
//                           height: '100%',
//                           borderTopLeftRadius: '0px',
//                           borderBottomLeftRadius: '0px',
//                           borderTopRightRadius: '3px',
//                           borderBottomRightRadius: '3px',
//                           '& .MuiSelect-select': {
//                             padding: '8px 16px',
//                             paddingRight: '24px !important',
//                             height: '100% !important',
//                             display: 'flex',
//                             alignItems: 'center'
//                           },
//                           '& .MuiOutlinedInput-notchedOutline': {
//                             border: 'none'
//                           },
//                           '&:hover': {
//                             background: '#e0e0e0',
//                           },
//                           '&.Mui-focused': {
//                             background: '#e0e0e0',
//                           },
//                           borderLeft: '1px solid #ced4da'
//                         }}
//                       >
//                         <MenuItem value="withTax">Inclusive</MenuItem>
//                         <MenuItem value="withoutTax">Exclusive</MenuItem>
//                       </Select>
//                     )}
//                   </Box>
//                   {hasGstNumber && (
//                     <Box sx={{
//                       p: '8px 12px',
//                       backgroundColor: '#e9ecef',
//                       border: '1px solid #ced4da',
//                       borderTop: 'none',
//                       borderRadius: '0 0 4px 4px',
//                       display: 'flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                     }}>
//                       <span style={{ fontSize: '14px', fontWeight: 'bold', color: '#333' }}>Taxable Value: {taxableValue}</span>
//                     </Box>
//                   )}
//                 </FormControl>
//               </Grid>
//             <Grid item xs={12} md={3}>
//               <TextInputs
//                 title={'Product Count'}
//                 name={'productCount'}
//                 placeholder="0"
//                 value={formData?.productCount}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//                 fieldValidation={productCountValidation && formValidation.productCountValidation}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         <Box style={{ marginTop: '20px' }}>
//           <Grid container spacing={3}>
//             {/* <Grid item xs={12} md={3}>
//               <TextInputs
//                 required={false}
//                 title={'Bar Code'}
//                 name={'barcode'}
//                 // placeholder="0"
//                 value={formData?.barcode}
//                 handleChange={handleChange}
//                 type={'number'}
//               />
//             </Grid> */}
//             {/* <Grid item xs={12} md={3}>
//               <TextInputs
//                 required={false}
//                 title={'Reward Points'}
//                 name={'rewardPoints'}
//                 // placeholder="0"
//                 value={formData?.rewardPoints}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//               />
//             </Grid> */}
//             <Grid item xs={12} md={3}>
//               <TextInputs
//                 required={false}
//                 title={'Staff Incentive'}
//                 name={'staffIncentive'}
//                 placeholder="0"
//                 value={formData?.staffIncentive}
//                 handleChange={handleChange}
//                 type={'number'}
//                 min={'0'}
//               />
//             </Grid>
//             <Grid item xs={12} md={3}>
//               <div style={{ marginBottom: '5px', fontWeight: 'bold', color: 'black' }}>Incentive Type</div>
//               <ToggleButtonGroup
//                 value={formData.incentiveType}
//                 exclusive
//                 onChange={handleIncentiveTypeChange}
//                 aria-label="incentive type"
//                 fullWidth
//                 sx={{
//                   borderRadius: '4px',
//                   // height: '30px',
//                   height: '3.4rem',
//                   width: '160px',
//                   backgroundColor: '#f0f0f0',
//                 }}
//               >
//                 {incentiveTypes.map((type) => (
//                   <ToggleButton
//                     key={type}
//                     value={type}
//                     aria-label={type}
//                     sx={{
//                       color: '#000',
//                       backgroundColor: '#e0e0e0',
//                       width: '160px',
//                       height: '3.4rem',
//                       '&.Mui-selected': {
//                         backgroundColor: '#6174DD',
//                         color: '#fff',
//                         '&:hover': {
//                           backgroundColor: '#6174DD',
//                         },
//                       },
//                       '&:not(.Mui-selected)': {
//                         '&:hover': {
//                           backgroundColor: '#d0d0d0',
//                         },
//                       }
//                     }}
//                   >
//                     {type}
//                   </ToggleButton>
//                 ))}
//               </ToggleButtonGroup>
//             </Grid>
//             {/* <Grid item xs={12} md={3} style={{ width: '185px' }}>
//               <TextInputs
//                 title={'HSN Code'}
//                 ref={productNameInputRef}
//                 name={'hsnCode'}
//                 value={formData?.hsnCode}
//                 handleChange={handleChange}
//                 type={'text'}
//                 placeholder={'HSN Code'}
//                 required={false}
//               // fieldValidation={hsnCodeValidation && formValidation.productNameValidation}
//               />
//             </Grid> */}
//           </Grid>
//           {hasGstNumber && (
//             <Grid container spacing={3} style={{ marginTop: '5px' }}>
//               <Grid item xs={12} md={3} style={{ width: '185px' }}>
//                 <SelectInputs
//                   name={'GST'}
//                   value={formData.GST}
//                   title={'GST %'}
//                   handleChange={handleChange}
//                   options={[
//                     {
//                       value: 5,
//                       title: '5%',
//                     },
//                     {
//                       value: 12,
//                       title: '12%',
//                     },
//                     {
//                       value: 18,
//                       title: '18%',
//                     },
//                   ]}
//                   optionValue={'value'}
//                   optionTitle={'title'}
//                 />
//               </Grid>
//             </Grid>
//           )}
//         </Box>

//         <div style={{ width: '200px', margin: '3rem auto' }}>
//           {loading ? (
//             <ShowLoader />
//           ) : (
//             <Button
//               variant="contained"
//               fullWidth
//               color="primary"
//               target="_blank"
//               sx={{
//                 background: '#6174DD',
//               }}
//               onClick={handleSubmit}
//             >
//               Add Product
//             </Button>
//           )}
//         </div>
//       </DashboardCard>
//     </PageContainer>
//   );
// };

// export default AddProduct;
import React, { useState, useEffect, useRef, useMemo } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard from 'src/components/shared/DashboardCard';
import {
  Button,
  Grid,
  MenuItem,
  Select,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Autocomplete,
  TextField,
  Typography,
  IconButton,
} from '@mui/material';
import { Box } from '@mui/system';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import { useMain } from '../hooks/useMain';
import Suggestion from './Suggestion';
import ProductPreview from './components/ProductPreview';

// ---------------------------------------------------------------------------
// Category -> Subcategory mapping
// ---------------------------------------------------------------------------
const CATEGORY_SUBCATEGORY_MAP = {
  'Hair Care': ['Shampoo', 'Conditioner', 'Hair Mask', 'Hair Serum', 'Hair Oil', 'Scalp Care' , 'Other'],
  'Hair Styling': [
    'Hair Spray',
    'Hair Wax',
    'Hair Gel',
    'Hair Mousse',
    'Styling Cream',
    'Hair Pomade',
    'Heat Protection',
    'Other'
  ],
  'Hair Color': [
    'Hair Color',
    'Hair Bleach',
    'Developer',
    'Toner',
    'Color Protect',
    'Color Remover',
    'Root Touch-Up',
    'Other'
  ],
  'Skin Care': ['Face Wash', 'Face Scrub', 'Toner', 'Moisturizer', 'Face Serum', 'Sunscreen', 'Face Oil', 'Other'],
  'Facial & Cleanup': [
    'Facial Kit',
    'Cleanup Kit',
    'Face Mask',
    'Face Peel',
    'Bleach',
    'Facial Cream',
    'Facial Gel',
    'Facial Treatment',
    'Other'
  ],
  'Manicure & Pedicure': [
    'Nail Polish',
    'Nail Remover',
    'Nail Care',
    'Scrub',
    'Cream',
    'Manicure Kit',
    'Pedicure Kit',
    'Nail Tools',
    'Nail Art',
    'Other'
  ],
  Waxing: ['Wax', 'Wax Strips', 'Pre-Wax Care', 'Post-Wax Care', 'Waxing Accessories', 'Other'],
  Makeup: [
    'Foundation',
    'Concealer',
    'Compact',
    'Primer',
    'Blush',
    'Highlighter',
    'Lipstick',
    'Lip Gloss',
    'Eye Makeup',
    'Eyeshadow',
    'Makeup Remover',
    'Setting Products',
    'Other',
  ],
  'Salon Consumables': [
    'Disposable',
    'Cotton Products',
    'Tissues',
    'Applicators',
    'Foils',
    'Protective Items',
    'Cleaning Supplies',
    'Other'
  ],
  'Aftercare / Retail': [
    'Hair Aftercare',
    'Hair Treatment',
    'Color Aftercare',
    'Skin Aftercare',
    'Facial Aftercare',
    'Nail Aftercare',
    'Sun Care',
    'Professional Home Kits',
    'Other'
  ],
  'Other' : ['Other'],
};

const CATEGORY_OPTIONS = Object.keys(CATEGORY_SUBCATEGORY_MAP);

const initialValue = {
  productName: '',
  category: '',
  subcategory: '',
  volume: '',
  unit: 'ml',
  productCount: '',
  sellPrice: '',
  rewardPoints: '',
  staffIncentive: '',
  incentiveType: '%',
  hsnCode: '',
  GST: 18,
  taxStatus: 'noGst',
  logo: null,
};

const initialFormValidation = {
  productNameValidation: false,
  sellPriceValidation: false,
  productCountValidation: false,
  categoryValidation: false,
  subcategoryValidation: false,
};

const AddProduct = () => {
  const { createProduct, activeBranchId, getBranch, setShowMessage, branchData } = useMain();

  const [formData, setFormData] = useState(initialValue);
  const [formValidation, setFormValidation] = useState(initialFormValidation);
  const [productData, setProductData] = useState([]);
  const [suggested, setSuggested] = useState([]);
  const [activeField, setActiveField] = useState('');
  const [loading, setLoading] = useState(false);
  const [enableIncentive, setEnableIncentive] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState(null);
  const hasGstNumber = Boolean(String(branchData?.gstNumber || '').trim());

  const productNameInputRef = useRef(null);
  const fileInputRef = useRef(null);

  const productNameValidation = !formData.productName.trim();
  const sellPriceValidation = !formData.sellPrice || !(Number(formData.sellPrice) > 0);
  const productCountValidation = !formData.productCount || !(Number(formData.productCount) > 0);
  const categoryValidation = !formData.category;
  const subcategoryValidation = !formData.subcategory;

  // Subcategory options derived from the selected category
  const subcategoryOptions = useMemo(() => {
    return formData.category ? CATEGORY_SUBCATEGORY_MAP[formData.category] || [] : [];
  }, [formData.category]);

  const taxableValue = useMemo(() => {
    const p = Number(formData.sellPrice) || 0;
    const gstRate = Number(formData.GST) || 0;
    if (hasGstNumber && formData.taxStatus === 'withTax' && gstRate > 0) {
      return (p / (1 + gstRate / 100)).toFixed(2);
    }
    return p.toFixed(2);
  }, [formData.sellPrice, formData.GST, formData.taxStatus, hasGstNumber]);

  const gstValue = useMemo(() => {
    const p = Number(formData.sellPrice) || 0;
    const gstRate = Number(formData.GST) || 0;
    if (!hasGstNumber || gstRate <= 0) return '0.00';
    if (formData.taxStatus === 'withTax') {
      return (p - Number(taxableValue)).toFixed(2);
    }
    return ((p * gstRate) / 100).toFixed(2);
  }, [formData.sellPrice, formData.GST, formData.taxStatus, taxableValue, hasGstNumber]);

  const payableValue = useMemo(() => {
    const sellPrice = Number(formData.sellPrice) || 0;
    const gst = Number(gstValue) || 0;
    if (formData.taxStatus === 'withoutTax') {
      return (sellPrice + gst).toFixed(2);
    }
    return sellPrice.toFixed(2);
  }, [formData.sellPrice, gstValue, formData.taxStatus]);

  const staffEarns = useMemo(() => {
    const price = Number(formData.sellPrice) || 0;
    const incentive = Number(formData.staffIncentive) || 0;
    if (!enableIncentive) return '0.00';
    if (formData.incentiveType === '%') {
      return ((price * incentive) / 100).toFixed(2);
    }
    return incentive.toFixed(2);
  }, [formData.sellPrice, formData.staffIncentive, formData.incentiveType, enableIncentive]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (productNameInputRef.current) {
        productNameInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (name === 'productName') {
      updateSuggested(name, value);
    }
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleProductNameChange = (e) => {
    const value = e.target.value.trimStart();
    setFormData((prev) => ({ ...prev, productName: value }));
    updateSuggested('productName', value);
  };

  // Trims the pasted text, then inserts it at the cursor position
  const handleProductNamePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData('text').trim();
    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setFormData((prev) => ({ ...prev, productName: next }));
    updateSuggested('productName', next);
  };

  // Trims trailing spaces when the user leaves the box
  const handleProductNameBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      setFormData((prev) => ({ ...prev, productName: trimmed }));
    }
  };

  // When category changes, reset subcategory (since old subcategory may not belong to new category)
  const handleCategoryChange = (e, newValue) => {
    setFormData((prev) => ({
      ...prev,
      category: newValue || '',
      subcategory: '',
    }));
  };

  // When user tries to open subcategory dropdown without selecting category first, warn them
  const handleSubcategoryOpen = () => {
    if (!formData.category) {
      setShowMessage({
        message: 'Please select a category first.',
        messageType: 'error',
      });
    }
  };

  const handleSubcategoryChange = (e, newValue) => {
    if (!formData.category) {
      setShowMessage({
        message: 'Please select a category first.',
        messageType: 'error',
      });
      return;
    }
    setFormData((prev) => ({ ...prev, subcategory: newValue || '' }));
  };
  const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result); // e.g. "data:image/jpeg;base64,...."
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (imagePreviewUrl) {
      URL.revokeObjectURL(imagePreviewUrl);
    }
    setImagePreviewUrl(null);
    setFormData((prev) => ({ ...prev, logo: null }));

    if (file) {
      // Validation: File size
      if (file.size > 100 * 1024) {
        setShowMessage({
          message: 'File size must not exceed 100KB.',
          messageType: 'error',
        });
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        return;
      }

      const img = new Image();
      const objectUrl = URL.createObjectURL(file);

      img.onload = () => {
        const { width, height } = img;
        const aspectRatio = width / height;
        const allowedRatios = [1, 4 / 5, 3 / 4];
        const isAllowed = allowedRatios.some(ratio => Math.abs(aspectRatio - ratio) < 0.01);

        if (!isAllowed) {
          setShowMessage({
            message: 'Invalid aspect ratio. Allowed ratios are 1:1, 4:5, or 3:4.',
            messageType: 'error',
          });
          URL.revokeObjectURL(objectUrl);
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
        } else {
          setImagePreviewUrl(objectUrl);
          setFormData((prev) => ({ ...prev, logo: file }));
        }
      };

      img.onerror = () => {
        setShowMessage({
          message: 'Invalid file type. Please upload a valid image.',
          messageType: 'error',
        });
        URL.revokeObjectURL(objectUrl);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      };

      img.src = objectUrl;
    }
  };

  const handleRemoveImage = () => {
    if (imagePreviewUrl) {
      URL.revokeObjectURL(imagePreviewUrl);
    }
    setImagePreviewUrl(null);
    setFormData((prev) => ({ ...prev, logo: null }));
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const updateSuggested = (fieldName, inputValue) => {
    if (inputValue === '') {
      setSuggested([]);
    } else {
      const suggestions = productData
        .filter((product) => product?.productName?.toLowerCase().includes(inputValue.toLowerCase()))
        .map((product) => product.productName);
      setSuggested(suggestions);
    }
  };

  const handleSuggestedClick = (suggestedName) => {
    setFormData((prev) => ({ ...prev, productName: suggestedName }));
    setSuggested([]);
  };

  const handleTaxStatusSelect = (status) => {
    setFormData((prev) => ({ ...prev, taxStatus: status }));
  };

  const handleIncentiveTypeChange = (e) => {
    setFormData({ ...formData, incentiveType: e.target.value });
  };

  const handleSubmit = async () => {
  const { productName, productCount, sellPrice, taxStatus, category, subcategory } = formData;

  const validation = {
    productNameValidation: !productName.trim(),
    sellPriceValidation: !sellPrice || !(Number(sellPrice) > 0),
    productCountValidation: !productCount || !(Number(productCount) > 0),
    taxStatusValidation: hasGstNumber ? !taxStatus || taxStatus === 'noGst' : false,
    categoryValidation: !category,
    subcategoryValidation: !subcategory,
  };

  setFormValidation((pre) => ({ ...pre, ...validation }));
  if (Object.values(validation).some((item) => item)) return;

  try {
    setLoading(true);

    let logoObject = null;
    if (formData.logo) {
      const base64Image = await fileToBase64(formData.logo);
      logoObject = { url: base64Image, public_id: formData.logo.name };
    }

    const {purchasePrice, mrp, ...restFormData } = formData;

    const payload = {
      ...restFormData,
      productName: formData.productName.trim(),
      logo: logoObject,
      GST: hasGstNumber ? formData.GST : 0,
      taxStatus: hasGstNumber ? formData.taxStatus : 'noGst',
      taxableValue,
      staffIncentive: enableIncentive ? formData.staffIncentive : 0,
      branchDetails: activeBranchId,
    };
    delete payload.mrp;
    delete payload.purchasePrice;

    const res = await createProduct(JSON.stringify(payload));
    if (res?.statusCode === 200) {
      setShowMessage({ message: res.message || 'Product has been created successfully', messageType: 'success' });
      setFormData(initialValue);
      setEnableIncentive(false);
      setFormValidation((pre) => ({ ...initialFormValidation }));
    } else {
      setShowMessage({ message: res.message || 'Something went wrong', messageType: 'error' });
    }
  } catch (error) {
    setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
  } finally {
    setLoading(false);
  }
};

  const handleInputFocus = () => {
    setSuggested([]);
    const activeElement = document.activeElement;
    if (activeElement && activeElement.getAttribute('name')) {
      setActiveField(activeElement.getAttribute('name'));
    } else {
      setActiveField('');
    }
  };

  useEffect(() => {
    document.addEventListener('focus', handleInputFocus, true);
    return () => {
      document.removeEventListener('focus', handleInputFocus, true);
    };
  }, [activeField]);

  const getData = async () => {
    try {
      const res = await getBranch(activeBranchId);
      if (res.statusCode === 200) {
        const data = res?.data;
        setProductData(data?.products || []);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (activeBranchId) getData();
  }, [activeBranchId]);

  useEffect(() => {
    if (hasGstNumber) {
      setFormData((prev) => ({ ...prev, taxStatus: 'withTax' }));
    } else {
      setFormData((prev) => ({ ...prev, taxStatus: 'noGst' }));
    }
  }, [hasGstNumber]);

  useEffect(() => {
    // Revoke the object URL on component unmount
    return () => {
      if (imagePreviewUrl) {
        URL.revokeObjectURL(imagePreviewUrl);
      }
    };
  }, [imagePreviewUrl]);

  // ---- Shared style helpers ----
  const sectionBoxStyle = {
    border: '1px solid #e8e9f2',
    borderRadius: '12px',
    padding: '22px',
    marginBottom: '20px',
    background: '#fff',
    boxShadow: '0 1px 3px rgba(30,32,60,0.04)',
  };

  const sectionHeaderStyle = {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '20px',
  };

  const stepCircleStyle = {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #6174DD, #7C8FF2)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 700,
    fontSize: '13px',
    boxShadow: '0 2px 6px rgba(97,116,221,0.35)',
  };

  const fieldLabelStyle = {
    fontSize: '14px',
    fontWeight: 600,
    marginBottom: '6px',
    display: 'block',
    color: '#212529',
    minHeight: '18px',
  };

  const helperTextStyle = {
    fontSize: '12px',
    color: '#8a8f98',
    marginTop: '4px',
  };

  const inputBoxStyle = (hasError) => ({
    display: 'flex',
    alignItems: 'center',
    border: `1px solid ${hasError ? '#e53935' : '#ced4da'}`,
    borderRadius: '6px',
    height: '48px',
    transition: 'border-color 0.2s ease-in-out',
    '&:hover': { borderColor: '#6174DD' },
  });

  const plainInputStyle = {
    border: 'none',
    outline: 'none',
    flex: 1,
    padding: '0 12px',
    fontSize: '15px',
    background: 'transparent',
    width: '100%',
    height: '100%',
  };

  const autocompleteSx = (hasError) => ({
    '& .MuiOutlinedInput-root': {
      height: '48px',
      borderRadius: '6px',
      fontSize: '15px',
      '& fieldset': {
        borderColor: hasError ? '#e53935' : '#ced4da',
      },
      '&:hover fieldset': {
        borderColor: '#6174DD',
      },
    },
    '& .MuiInputBase-input': {
      padding: '0 !important',
    },
  });

  return (
    <PageContainer title="Add New Product" description="This is add Product">
      <DashboardCard title="Add New Product">
        <Grid container spacing={3} style={{ marginTop: '4px' }}>
          {/* ---------------- LEFT: FORM ---------------- */}
          <Grid item xs={12} md={8}>
            {/* 1. Basic Information */}
            <Box sx={sectionBoxStyle}>
              <Box sx={sectionHeaderStyle}>
                <Box sx={stepCircleStyle}>1</Box>
                <Box>
                  <div style={{ fontWeight: 700, fontSize: '17px' }}>Basic Information</div>
                  <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                    Enter basic details about your product.
                  </div>
                </Box>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <label style={fieldLabelStyle}>
                    Product Name <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Box
                    sx={inputBoxStyle(productNameValidation && formValidation.productNameValidation)}
                  >
                    <input
                      ref={productNameInputRef}
                      name="productName"
                      value={formData?.productName || ''}
                      onChange={handleProductNameChange}
                      onPaste={handleProductNamePaste}
                      onBlur={handleProductNameBlur}
                      type="text"
                      placeholder="e.g. L'Oréal Shampoo"
                      style={plainInputStyle}
                      autoComplete="off"
                    />
                  </Box>
                  <div style={helperTextStyle}>This name will appear in billing and inventory.</div>
                  {suggested.length > 0 && activeField === 'productName' && (
                    <Suggestion data={suggested} handleSuggestedClick={handleSuggestedClick} />
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>
                    Category <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Autocomplete
                    options={CATEGORY_OPTIONS}
                    value={formData.category || null}
                    onChange={handleCategoryChange}
                    sx={autocompleteSx(categoryValidation && formValidation.categoryValidation)}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Search or select category" />
                    )}
                  />
                  <div style={helperTextStyle}>Choose the product's main category.</div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>
                    Subcategory <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Tooltip
                    title={!formData.category ? 'Please select a category first' : ''}
                    disableHoverListener={Boolean(formData.category)}
                  >
                    <span>
                      <Autocomplete
                        options={subcategoryOptions}
                        value={formData.subcategory || null}
                        onChange={handleSubcategoryChange}
                        onOpen={handleSubcategoryOpen}
                        disabled={!formData.category}
                        sx={autocompleteSx(subcategoryValidation && formValidation.subcategoryValidation)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              formData.category ? 'Search or select subcategory' : 'Select category first'
                            }
                          />
                        )}
                      />
                    </span>
                  </Tooltip>
                  <div style={helperTextStyle}>
                    {formData.category
                      ? "Narrow it down within the category."
                      : 'Select a category to see available subcategories.'}
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>
                    HSN Code (Optional){' '}
                    <Tooltip title="Harmonized System Nomenclature code, used for GST reporting.">
                      <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', verticalAlign: 'middle' }} />
                    </Tooltip>
                  </label>
                  <Box sx={inputBoxStyle(false)}>
                    <input
                      name="hsnCode"
                      value={formData?.hsnCode}
                      onChange={handleChange}
                      type="text"
                      placeholder="e.g. 33051010"
                      style={plainInputStyle}
                    />
                  </Box>
                  <div style={helperTextStyle}>Used for GST reporting.</div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>
                    Pack Size <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Box sx={inputBoxStyle(false)}>
                    <input
                      name="volume"
                      placeholder="500"
                      value={formData?.volume}
                      onChange={handleChange}
                      type="number"
                      min="0"
                      style={plainInputStyle}
                    />
                    <Select
                      name="unit"
                      value={formData?.unit}
                      onChange={handleChange}
                      displayEmpty
                      sx={{
                        background: '#F5F5F7',
                        border: 'none',
                        height: '100%',
                        minWidth: '70px',
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderTopRightRadius: '6px',
                        borderBottomRightRadius: '6px',
                        '& .MuiSelect-select': {
                          padding: '0 14px',
                          height: '100% !important',
                          display: 'flex',
                          alignItems: 'center',
                        },
                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                        borderLeft: '1px solid #ced4da',
                      }}
                    >
                      {['ml', 'l', 'gm', 'kg'].map((type) => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <div style={helperTextStyle}>Enter the size of one unit/package.</div>
                </Grid>

                <Grid item xs={12}>
                  <label style={fieldLabelStyle}>
                    Product Image (Optional){' '}
                    <Tooltip title="Upload an image for your product.">
                      <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', verticalAlign: 'middle' }} />
                    </Tooltip>
                  </label>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<CloudUploadIcon />}
                      sx={{
                        background: '#6174DD',
                        '&:hover': { background: '#5365c1' },
                        textTransform: 'none',
                        fontSize: '14px',
                        padding: '8px 16px',
                        height: '40px',
                      }}
                    >
                      Upload Image
                      <input
                        ref={fileInputRef}
                        name="logo"
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        hidden
                      />
                    </Button>
                    {formData.logo && (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{
                            maxWidth: '150px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {formData.logo.name}
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{ color: '#e53935' }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                  <div style={helperTextStyle}>Upload a clear image of the product (e.g., JPEG, PNG).</div>
                </Grid>
              </Grid>
            </Box>

            {/* 2. Pricing & Tax */}
            <Box sx={sectionBoxStyle}>
              <Box sx={sectionHeaderStyle}>
                <Box sx={stepCircleStyle}>2</Box>
                <Box>
                  <div style={{ fontWeight: 700, fontSize: '17px' }}>Pricing & Tax</div>
                  <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                    Set the selling price and tax details.
                  </div>
                </Box>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} md={hasGstNumber ? 6 : 12}>
                  <label style={fieldLabelStyle}>
                    MRP <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Box sx={inputBoxStyle(sellPriceValidation && formValidation.sellPriceValidation)}>
                    <span style={{ padding: '0 10px', fontSize: '15px', color: '#666' }}>₹</span>
                    <input
                      name="sellPrice"
                      placeholder="0.00"
                      value={formData?.sellPrice}
                      onChange={handleChange}
                      type="number"
                      min="0"
                      style={{ ...plainInputStyle, padding: '0 12px 0 0' }}
                    />
                  </Box>
                  <div style={helperTextStyle}>Maximum Retail Price (selling price)</div>
                </Grid>

                {hasGstNumber && (
                  <Grid item xs={12} md={6}>
                    <label style={fieldLabelStyle}>
                      GST Rate <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                      name="GST"
                      value={formData.GST}
                      onChange={handleChange}
                      fullWidth
                      sx={{ height: '48px', borderRadius: '6px' }}
                    >
                      {[5, 12, 18].map((rate) => (
                        <MenuItem key={rate} value={rate}>
                          {rate}%
                        </MenuItem>
                      ))}
                    </Select>
                    <div style={helperTextStyle}>Select applicable GST rate</div>
                  </Grid>
                )}
              </Grid>

              {hasGstNumber && (
                <Box sx={{ marginTop: '20px' }}>
                  <label style={fieldLabelStyle}>
                    Does MRP include GST? <span style={{ color: 'red' }}>*</span>{' '}
                    <Tooltip title="Choose whether the MRP you entered already has GST included, or if GST should be added on top.">
                      <InfoOutlinedIcon sx={{ fontSize: 15, color: '#9aa0a6', verticalAlign: 'middle' }} />
                    </Tooltip>
                  </label>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Box
                        onClick={() => handleTaxStatusSelect('withTax')}
                        sx={{
                          border: `1.5px solid ${formData.taxStatus === 'withTax' ? '#6174DD' : '#e0e0e0'}`,
                          backgroundColor: formData.taxStatus === 'withTax' ? '#f0f1fd' : '#fff',
                          borderRadius: '8px',
                          padding: '12px 14px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          cursor: 'pointer',
                          height: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        <Box
                          sx={{
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            border: `2px solid ${formData.taxStatus === 'withTax' ? '#6174DD' : '#c4c4c4'}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {formData.taxStatus === 'withTax' && (
                            <Box sx={{ width: 9, height: 9, borderRadius: '50%', background: '#6174DD' }} />
                          )}
                        </Box>
                        <Box>
                          <div style={{ fontWeight: 600, fontSize: '14px' }}>Inclusive GST</div>
                          <div style={{ fontSize: '12px', color: '#8a8f98' }}>Price includes GST</div>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box
                        onClick={() => handleTaxStatusSelect('withoutTax')}
                        sx={{
                          border: `1.5px solid ${formData.taxStatus === 'withoutTax' ? '#6174DD' : '#e0e0e0'}`,
                          backgroundColor: formData.taxStatus === 'withoutTax' ? '#f0f1fd' : '#fff',
                          borderRadius: '8px',
                          padding: '12px 14px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                          cursor: 'pointer',
                          height: '100%',
                          boxSizing: 'border-box',
                        }}
                      >
                        <Box
                          sx={{
                            width: 18,
                            height: 18,
                            borderRadius: '50%',
                            border: `2px solid ${formData.taxStatus === 'withoutTax' ? '#6174DD' : '#c4c4c4'}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {formData.taxStatus === 'withoutTax' && (
                            <Box sx={{ width: 9, height: 9, borderRadius: '50%', background: '#6174DD' }} />
                          )}
                        </Box>
                        <Box>
                          <div style={{ fontWeight: 600, fontSize: '14px' }}>Exclusive GST</div>
                          <div style={{ fontSize: '12px', color: '#8a8f98' }}>Price excludes GST</div>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>

                  {/* Price Summary */}
                  <Box
                    sx={{
                      marginTop: '18px',
                      background: 'linear-gradient(135deg, #f5f6fb, #eef0fa)',
                      border: '1px solid #e3e5f5',
                      borderRadius: '8px',
                      padding: '14px 16px',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
                      <LocalOfferOutlinedIcon sx={{ fontSize: 18, color: '#6174DD' }} />
                      <span style={{ fontWeight: 700, fontSize: '14px', color: '#6174DD' }}>
                        Price Summary
                      </span>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '8px' }}>
                      <span>MRP (Selling Price)</span>
                      <span>₹{Number(formData.sellPrice || 0).toFixed(2)}</span>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 700 , marginBottom: '8px'}}>
                      <span>Taxable Value</span>
                      <span style={{ color: '#2e7d32' }}>₹{taxableValue}</span>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginBottom: '8px' }}>
                      <span>GST ({formData.GST}%)</span>
                      <span>₹{gstValue}</span>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', fontWeight: 700, marginTop: '8px' }}>
                      <span>Payable Value</span>
                      <span style={{ color: '#2e7d32' }}>₹{payableValue}</span>
                    </Box>
                    <div style={{ fontSize: '11px', color: '#8a8f98', marginTop: '8px' }}>
                      This is an auto-calculated value based on your input.
                    </div>
                  </Box>
                </Box>
              )}
            </Box>

            {/* 3. Inventory */}
            <Box sx={sectionBoxStyle}>
              <Box sx={sectionHeaderStyle}>
                <Box sx={stepCircleStyle}>3</Box>
                <Box>
                  <div style={{ fontWeight: 700, fontSize: '17px' }}>Inventory</div>
                  <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                    Set the opening stock for this product.
                  </div>
                </Box>
              </Box>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <label style={fieldLabelStyle}>
                    Opening Stock <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Box sx={inputBoxStyle(productCountValidation && formValidation.productCountValidation)}>
                    <Inventory2OutlinedIcon sx={{ fontSize: 18, color: '#9aa0a6', marginLeft: '10px' }} />
                    <input
                      name="productCount"
                      placeholder="20"
                      value={formData?.productCount}
                      onChange={handleChange}
                      type="number"
                      min="0"
                      style={plainInputStyle}
                    />
                  </Box>
                  <div style={helperTextStyle}>Number of units currently available in stock.</div>
                </Grid>
              </Grid>
            </Box>

            {/* 4. Staff Incentive */}
            <Box sx={sectionBoxStyle}>
              <Box sx={sectionHeaderStyle}>
                <Box sx={stepCircleStyle}>4</Box>
                <Box>
                  <div style={{ fontWeight: 700, fontSize: '17px' }}>Staff Incentive (Optional)</div>
                  <div style={{ fontSize: '13px', color: '#8a8f98' }}>
                    Set incentive for staff on sales of this product.
                  </div>
                </Box>
              </Box>

              <FormControlLabel
                control={
                  <Checkbox
                    checked={enableIncentive}
                    onChange={(e) => setEnableIncentive(e.target.checked)}
                    sx={{ color: '#6174DD', '&.Mui-checked': { color: '#6174DD' } }}
                  />
                }
                label={<span style={{ fontWeight: 600, color: '#6174DD', fontSize: '14px' }}>Enable staff incentive</span>}
              />

              {enableIncentive && (
                <Grid container spacing={2} alignItems="flex-start" sx={{ marginTop: '4px' }}>
                  <Grid item xs={12} md={4}>
                    <label style={fieldLabelStyle}>Incentive</label>
                    <Box sx={inputBoxStyle(false)}>
                      <input
                        name="staffIncentive"
                        placeholder="10"
                        value={formData?.staffIncentive}
                        onChange={handleChange}
                        type="number"
                        min="0"
                        style={plainInputStyle}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <label style={fieldLabelStyle}>Type</label>
                    <Select
                      name="incentiveType"
                      value={formData.incentiveType}
                      onChange={handleIncentiveTypeChange}
                      fullWidth
                      sx={{ height: '48px', borderRadius: '6px' }}
                    >
                      <MenuItem value="%">Percentage (%)</MenuItem>
                      <MenuItem value="INR">Flat (₹)</MenuItem>
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <label style={fieldLabelStyle}>&nbsp;</label>
                    <Box
                      sx={{
                        background: '#eef8f0',
                        border: '1px solid #cfe8d4',
                        borderRadius: '8px',
                        padding: '6px 14px',
                        height: '48px',
                        boxSizing: 'border-box',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                      }}
                    >
                      <span style={{ fontSize: '11px', color: '#2e7d32' }}>Staff earns</span>
                      <span style={{ fontSize: '14px', fontWeight: 700, color: '#2e7d32' }}>
                        ₹{staffEarns} <span style={{ fontWeight: 400, fontSize: '10px' }}>per unit</span>
                      </span>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <div style={helperTextStyle}>Incentive given to staff on each sale.</div>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>

          <ProductPreview
            formData={formData}
            imagePreviewUrl={imagePreviewUrl}
            hasGstNumber={hasGstNumber}
            taxableValue={taxableValue}
            gstValue={gstValue}
            enableIncentive={enableIncentive}
            payableValue={payableValue}
          />
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '10px' }}>
          {loading ? (
            <ShowLoader />
          ) : (
            <Button
              variant="contained"
              color="primary"
              sx={{ background: '#6174DD', padding: '10px 28px' }}
              onClick={handleSubmit}
            >
              Add Product
            </Button>
          )}
        </Box>
      </DashboardCard>
    </PageContainer>
  );
};

export default AddProduct;